import axios from 'axios';

// Em produção (Cloud Run), frontend e backend estão no mesmo domínio, então usamos URL relativa
// Em desenvolvimento, usa a variável de ambiente ou fallback para localhost
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8000/api');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('user');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const clientesService = {
  list: (params = {}) => api.get('/clientes/', { params }),
  listOtimizada: (params = {}) => api.get('/clientes/lista-otimizada/', { params }),
  getById: (id) => api.get(`/clientes/${id}/`),
  detalhes: (id) => api.get(`/clientes/${id}/detalhes/`),
  contasAbertas: (id) => {
    console.log('Chamando contasAbertas para cliente:', id);
    return api.get(`/clientes/${id}/contas_abertas/`);
  },
  comContasAbertas: (limit = 50, params = {}) => {
    console.log('Chamando comContasAbertas com limite:', limit, 'e params:', params);
    return api.get('/clientes/com-contas-abertas/', { 
      params: { 
        limit, 
        ...params 
      } 
    });
  },
};

export const contasReceberService = {
  getContas: (params = {}) => api.get('/contas-receber/', { params }),
  getConta: (id) => api.get(`/contas-receber/${id}/`),
  baixarConta: (id, baixaData) => api.put(`/contas-receber/${id}/baixar/`, baixaData),
  atualizarConta: (id, data) => api.put(`/contas-receber/${id}/`, data),
  criarConta: (data) => api.post('/contas-receber/', data),
  excluirConta: (id) => api.delete(`/contas-receber/${id}/`),
};

export const cobrancaService = {
  list: (params = {}) => api.get('/controles-cobranca/', { params }),
  getById: (id) => api.get(`/controles-cobranca/${id}/`),
  porCliente: (clienteId) => api.get('/controles-cobranca/por_cliente/', { params: { cliente_id: clienteId } }),
  pendentes: () => api.get('/controles-cobranca/pendentes/'),
  proximasCobrancas: () => api.get('/controles-cobranca/proximas_cobrancas/'),
  contasCliente: (id) => api.get(`/controles-cobranca/${id}/contas_cliente/`),
  create: (data) => api.post('/controles-cobranca/', data),
  update: (id, data) => api.put(`/controles-cobranca/${id}/`, data),
  delete: (id) => api.delete(`/controles-cobranca/${id}/`),
};

export const dashboardService = {
  resumo: () => api.get('/dashboard/resumo/'),
  clientesPrioritarios: () => api.get('/dashboard/clientes_prioritarios/'),
  contasVencidas: () => api.get('/dashboard/contas_vencidas/'),
  contasVencendoBreve: () => api.get('/dashboard/contas_vencendo_breve/'),
};

export const sincronizacaoService = {
  statusApi: () => api.get('/sincronizacao/status_api/'),
  sincronizar: () => api.post('/sincronizacao/sincronizar_contas/'),
  sincronizarTodas: () => api.post('/sincronizacao/sincronizar_todas_contas/'),
  sincronizarUltraRapido: () => api.post('/sincronizacao/sincronizar_todas_contas_ultra_rapido/'),
  sincronizarCompleta: () => api.post('/sincronizacao/sincronizar_todas_contas_completa/'),
  sincronizarInteligente: () => api.post('/sincronizacao/sincronizar_inteligente/'),
};

export const authService = {
  login: (credentials) => api.post('/auth/login/', credentials),
  logout: () => api.post('/auth/logout/'),
  refresh: (refreshToken) => api.post('/auth/refresh/', { refresh_token: refreshToken }),
  usuarioAtual: () => api.get('/auth/usuario_atual/'),
};

export const perfilService = {
  list: () => api.get('/perfis-usuario/'),
  getById: (id) => api.get(`/perfis-usuario/${id}/`),
  create: (data) => api.post('/perfis-usuario/', data),
  update: (id, data) => api.put(`/perfis-usuario/${id}/`, data),
  delete: (id) => api.delete(`/perfis-usuario/${id}/`),
};

export const gestaoService = {
  dashboard: () => api.get('/gestao-cobranca/dashboard/'),
  relatorioFuncionario: (funcionarioId) => api.get('/gestao-cobranca/relatorio_funcionario/', { params: { funcionario_id: funcionarioId } }),
};

export const efetividadeService = {
  getEfetividade: (params) => api.get('/efetividade/', { params }),
  calcularEfetividade: (data) => api.post('/efetividade/calcular_efetividade/', data),
  getContasFechadas: (params) => api.get('/contas-fechadas/', { params }),
  getEfetividadeCobranca: (params) => api.get('/efetividade-cobranca/', { params }),
};

export const usuarioService = {
  list: (params = {}) => api.get('/usuarios/', { params }),
  getById: (id) => api.get(`/usuarios/${id}/`),
  create: (data) => api.post('/usuarios/', data),
  update: (id, data) => api.put(`/usuarios/${id}/`, data),
  delete: (id) => api.delete(`/usuarios/${id}/`),
  funcionarios: () => api.get('/usuarios/funcionarios/'),
  estatisticas: () => api.get('/usuarios/estatisticas/'),
};

export default api; 
